import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import UserSwitcherModal from './UserSwitcherModal';
import { revertToOriginalUser } from '../../utils/userSwitcher';

const UserSwitcherIcon = ({ user, sidebarCollapsed }) => {
  const [modalOpen, setModalOpen] = useState(false);
  const [isImpersonating, setIsImpersonating] = useState(false);
  const history = useHistory();
  
  // Check if currently impersonating a user
  useEffect(() => {
    setIsImpersonating(localStorage.getItem('isImpersonating') === 'true');
  }, []);
  
  // Only render for developer and bdo_staff user types
  if (
    !user || 
    (user.userType !== 'developer' && user.userType !== 'bdo_staff' && !isImpersonating)
  ) {
    return null;
  }
  
  const handleIconClick = (e) => {
    e.preventDefault();
    setModalOpen(true);
  };
  
  const handleRevert = async (e) => {
    e.preventDefault();
    try {
      const success = await revertToOriginalUser();
      if (success) {
        window.location.reload();
      }
    } catch (error) {
      console.error('Failed to revert to original user:', error);
    }
  };

  return (
    <>
      {isImpersonating ? (
        <a
          href="#"
          className="nav-link btn btn-icon btn-danger rounded-pill mx-0 mr-1"
          onClick={handleRevert}
          title="Return to Your Account"
          data-bs-toggle="tooltip"
          data-bs-placement="bottom"
          onMouseEnter={(e) => e.currentTarget.style.color = 'white'}
          onMouseLeave={(e) => e.currentTarget.style.color = ''}
        >
          <i className="icon-base ti tabler-user-minus icon-22px"></i>
        </a>
      ) : (
        <a
          href="#"
          className="nav-link btn btn-icon btn-text-secondary rounded-pill mx-0"
          onClick={handleIconClick}
          title="Switch User"
          data-bs-toggle="tooltip"
          data-bs-placement="bottom"
        >
          <i className="icon-base ti tabler-users icon-22px text-heading"></i>
        </a>
      )}
      
      <UserSwitcherModal 
        isOpen={modalOpen} 
        onClose={() => setModalOpen(false)}
        sidebarCollapsed={sidebarCollapsed}
      />
    </>
  );
};

export default UserSwitcherIcon;